import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';

import {
  CsvDownloadService,
  FormatService,
  ObservableChainService,
  RandomIdService,
  RxntIconService,
  RxntPopupConfigService,
  RxntPopupStateService,
} from '@rxnt/angular-components/core';
import { RxntLoadingSpinnerModule } from '@rxnt/angular-components/core-ui';
import { RxntDevextremeLicenseService } from '@rxnt/angular-components/dx-license';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    RxntLoadingSpinnerModule,
  ],
  providers: [
    ObservableChainService,
    RxntIconService,
    FormatService,
    RandomIdService,
    CsvDownloadService,
    RxntDevextremeLicenseService,
    RxntPopupConfigService,
    RxntPopupStateService,
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import(/* webpackChunkName: "highlight-core" */ 'highlight.js/lib/core'),
        languages: {
          xml: () => import(/* webpackChunkName: "highlight-lang" */ 'highlight.js/lib/languages/xml'),
          ts: () => import(/* webpackChunkName: "highlight-lang" */ 'highlight.js/lib/languages/typescript'),
          json: () => import(/* webpackChunkName: "highlight-lang" */ 'highlight.js/lib/languages/json'),
          scss: () => import(/* webpackChunkName: "highlight-lang" */ 'highlight.js/lib/languages/scss'),
        },
      },
    },
  ],
  bootstrap: [ AppComponent ],
})
export class AppModule {
}
